import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash/fp.js";
import { useSelector, useDispatch } from "react-redux";
import { ProductReviewDetails } from "../productReviewDetails/index.js";
import { ProductsTable } from "../productsTable/index.js";
import { fetchActionRequestDetails } from "../../actions/index.js";
import {
  retrieveCurrentReviewableAction,
  vendorDraftProductListSelector,
} from "../../selectors/index.js";
import { Section } from "../reusableComponents/Section/index.js";

// will need to be replaced with actual 'Loading' Indicator
const IsLoading = () => <Section title="Data Loading..." />;

const extractSearchParams = (searchParams) => {
  var params = new URLSearchParams(searchParams);
  var actionId = params.get("actionId");

  return actionId && parseInt(actionId);
};

export function MyProducts({ location }) {
  const dispatch = useDispatch();
  const draftInfo = useSelector(retrieveCurrentReviewableAction);
  const actionRequestId = extractSearchParams(location.search);
  const [showMyProductsTable, setShowMyProductsTable] = useState(false);
  const data = useSelector(vendorDraftProductListSelector);

  useEffect(() => {
    if (actionRequestId === null) {
      if (isEmpty(draftInfo)) {
        setShowMyProductsTable(true);
      } else {
        dispatch(fetchActionRequestDetails(draftInfo.id));
      }
    } else {
      if (isEmpty(draftInfo) || draftInfo.id !== actionRequestId) {
        dispatch(fetchActionRequestDetails(actionRequestId));
      }
    }
  }, []);

  const showActionReviewDetails = () => {
    return isEmpty(draftInfo) ? (
      <IsLoading />
    ) : (
      <ProductReviewDetails draftInfo={draftInfo} />
    );
  };

  return showMyProductsTable ? (
    <ProductsTable data={data} />
  ) : (
    showActionReviewDetails()
  );
}

MyProducts.propTypes = {
  location: PropTypes.shape({ search: PropTypes.string }),
};
